import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: (typeof window !== "undefined" && localStorage.getItem("antd-theme")) || "light",
  language : (typeof window !== "undefined" && localStorage.getItem("appLanguage")) || 'EN',
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme(state) {
      state.mode = state.mode === "dark" ? "light" : "dark";
      if (typeof window !== "undefined") {
        localStorage.setItem("antd-theme", state.mode);
        document.body.dataset.theme = state.mode; // opsiyonel
      }
    },
    setTheme(state, action) {
      state.mode = action.payload;
      if (typeof window !== "undefined") {
        localStorage.setItem("antd-theme", state.mode);
        document.body.dataset.theme = state.mode;
      }
    },

    setLanguage(state, action) {
      state.language = action.payload;
      if (typeof window !== "undefined") {
        localStorage.setItem("appLanguage", state.language);
      }
    }

  },
});

export const { toggleTheme, setTheme,setLanguage } = themeSlice.actions;
export default themeSlice.reducer;
